import { Component, OnInit,AfterViewInit ,OnDestroy,ViewChild} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as firebase from 'firebase';
import {ModalAccionesEmpresaComponent } from '../modal-acciones-empresa/modal-acciones-empresa.component'


@Component({
  selector: 'app-componente-data2',
  templateUrl: './componente-data2.component.html',
  styleUrls: ['./componente-data2.component.scss']
})
export class ComponenteData2Component implements OnInit, AfterViewInit, OnDestroy  {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<ComponenteData2Component> = new Subject();

  tablavisible = false;
  botondisabled=true

  arraydeposts: any[] = [];
  excelOTabla = 'tabla';
  pageSize: number = 20;
  cursor: any;
  infiniteEvent: any;

  nombre;
  dominio;
  responsable;
  alertaActiva=false
  mensajeAlerta='';
  tipodeAlerta='';

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
    this.inicializadatatables(()=>{
      this.query1(()=>{
        this.dtTrigger.next();
      })
    })
  }

  ngAfterViewInit(): void {
    
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {        
      // Destroy the table first
      dtInstance.destroy();
      //reload your data
      this.query1(()=>{
         // Call the dtTrigger to rerender after callback
         this.dtTrigger.next();
      })
    });
  }

  inicializadatatables(callback) {
    this.dtOptions = {
      // Declare the use of the extension in the dom parameter
      dom: 'Bfrtip',
      "pageLength": 200,
      scrollX: false,
   
      // Configure the buttons
      buttons: [
        'colvis',
        'excel',
        // 'columnsToggle',
        'print'
      ]
    };
    callback()
  }


  crearEmpresa(){
    firebase.firestore().collection("empresas").add({
      nombre:this.nombre,
      dominio:this.dominio,
      responsable:this.responsable
    }).then(()=>{
      this.alerta("success","¡Empresa creada con éxito!")
      this.rerender()
    }).catch((err)=>{
      this.alerta("danger",err)
    })
  }


  

  query1(callback){
    this.arraydeposts=[];
    let query1 = firebase.firestore().collection("empresas");
    
    query1.get().then((docs)=>{
      docs.forEach((doc)=>{
        this.arraydeposts.push(doc);
      })
    }).catch((err)=>{
      console.log(err);
    }).then(()=>{
      callback()
    })
  }

  




borra(callback) {
  this.arraydeposts=[];
  this.dtTrigger.unsubscribe();
  this.tablavisible = false;
  callback()
}


reseteaarray(callback) {
  this.arraydeposts = [];
  callback();
}




editarEmpresa(empresa){
  const modalRef = this.modalService.open(ModalAccionesEmpresaComponent);
  modalRef.componentInstance.usuario = empresa;//pasamos al modal el parámetro 

  //para recibir data desde el modal
  modalRef.result.then((result) => {
    if (result=="OK") {
      this.rerender()
      }
    });
}





validaboton(){
  console.log("validaboton activado")
    if( (this.nombre != '' && this.dominio !='' && this.responsable !='') ){this.botondisabled=false}
    if  (this.nombre == '' || this.dominio =='' || this.responsable =='') {this.botondisabled=true}
   
}


alerta(tipo,input){
  this.alertaActiva=true;
  this.mensajeAlerta=input;
  this.tipodeAlerta=tipo;
}



closeAlert(){
  this.alertaActiva=false
}



}//fin de clase
